import styled, { css } from "styled-components";
import { deviceMax } from "../../../utils/device";

export const DialogBackdrop = styled.div`
  align-items: center;
  backdrop-filter: blur(3px);
  background: rgba(26, 46, 71, 0.64);
  display: flex;
  inset: 0;
  justify-content: center;
  padding: 20px;
  position: fixed;
  z-index: 20;
`;

export const DialogPanel = styled.div(
  ({ theme }) => css`
    background: ${theme.colors.white};
    border: 1px solid ${theme.colors.brand.line};
    border-radius: ${theme.layout.radius.panel};
    box-shadow: 0 24px 90px rgba(16, 32, 48, 0.27);
    max-height: 100%;
    max-width: 530px;
    overflow-y: auto;
    padding: 32px;
    position: relative;
    width: 100%;
  `
);

export const DialogClose = styled.button(
  ({ theme }) => css`
    align-items: center;
    background: ${theme.colors.brand.soft};
    border: none;
    border-radius: 50%;
    color: ${theme.colors.brand.deep};
    cursor: pointer;
    display: flex;
    height: 34px;
    justify-content: center;
    position: absolute;
    right: 14px;
    top: 14px;
    width: 34px;

    svg {
      height: 17px;
      width: 17px;
    }
  `
);

export const DialogTitle = styled.h2(
  ({ theme }) => css`
    font-family: ${theme.typography.fonts.display};
    font-size: 28px;
    font-weight: 650;
    letter-spacing: -0.045em;
    line-height: 1.08;
    margin: 8px 0 16px;
    max-width: 390px;
  `
);

export const DialogDescription = styled.p(
  ({ theme }) => css`
    color: ${theme.colors.brand.muted};
    font-size: 14px;
    margin: 0;
  `
);

export const DialogActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 26px;

  a,
  button {
    font-size: 13px;
  }
`;

export const DialogNote = styled.p(
  ({ theme }) => css`
    color: ${theme.colors.brand.muted};
    font-size: 11px;
    line-height: 1.6;
    margin: 18px 0 0;

    @media ${deviceMax.phoneMax} {
      word-break: break-word;
    }
  `
);
